module.exports = __webpack_public_path__ + "static/laboheme1-6593314326722121699ad859175b0f6b.jpeg";